export default ({ COLORS }) => ({
  previewLink: {
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  date: {
    whiteSpace: 'nowrap'
  },
  checkboxChell: {
    borderLeft: `5px solid transparent`
  },
  unseen: {
    borderLeftColor: COLORS.RED.FADED
  }
})
